const IS_GEOLOCATION_SUPPORTED = !!navigator?.geolocation?.getCurrentPosition && false;

export default IS_GEOLOCATION_SUPPORTED;
